(function () {
  // Look up a typed search query against window.__searchToFilterMap
  // (built by snippets/search-filter-map.liquid from every collection
  // title/handle + every S&D-configured filter value on /collections/all).
  // If we have an exact case-insensitive match, return the URL Shopify
  // itself would have generated for that filter click — so header
  // search "Capri" lands on the same product set as a click on the
  // sidebar Capri row, instead of running through /search?q=… text
  // search which matches title/description/tags broadly.
  function lookupFilterUrl(query) {
    if (!query) return null;
    var map = window.__searchToFilterMap;
    if (!map) return null;
    var key = String(query).trim().toLowerCase();
    return map[key] || null;
  }

  // 1) /search?q=… direct hits — if q matches a known filter value,
  //    bounce immediately to that filter URL. Otherwise fall back to
  //    adding &type=product so the search section sees products-only
  //    results (correct counts + Load More).
  (function searchPageEntryGuard() {
    if (window.location.pathname !== '/search') return;
    var u = new URL(window.location.href);
    var q = (u.searchParams.get('q') || '').trim();
    if (!q) return;
    var filterUrl = lookupFilterUrl(q);
    if (filterUrl) {
      window.location.replace(filterUrl);
      return;
    }
    if (u.searchParams.get('type') !== 'product') {
      u.searchParams.set('type', 'product');
      window.location.replace(u.toString());
    }
  })();

  // 2) Intercept every search form's submit. If the typed term matches a
  //    known filter value, redirect to that filter URL instead of
  //    letting the form submit to /search.
  function bindSearchFormFilterRedirect() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.__searchFilterBound) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.__searchFilterBound = true;
      form.addEventListener('submit', function (e) {
        var filterUrl = lookupFilterUrl(input.value);
        if (filterUrl) {
          e.preventDefault();
          window.location.href = filterUrl;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSearchFormFilterRedirect);
  } else {
    bindSearchFormFilterRedirect();
  }

  function setQueryParam(url, key, value) {
    var u = new URL(url, window.location.origin);
    if (value === null || value === undefined || value === '') {
      u.searchParams.delete(key);
    } else {
      u.searchParams.set(key, value);
    }
    u.searchParams.delete('page');
    return u.toString();
  }

  // Generic AJAX swap: fetches `fetchUrl`, swaps grid/sidebar/load-more from response,
  // and pushes `displayUrl` to the address bar (defaults to fetchUrl).
  // opts.preserveFilters = true → keep the existing filter blocks in the sidebar
  // (used for searches against /search, where the response has no collection filters).
  function ajaxNavigate(fetchUrl, displayUrl, opts) {
    opts = opts || {};
    var preserveFilters = !!opts.preserveFilters;

    var page = document.querySelector('.collection-page');
    if (page) page.classList.add('is-loading');

    // Snapshot search inputs before the swap so we can restore value + focus + caret.
    // (The swapped sidebar/grid markup can contain its own copy of these inputs
    // with an empty value, which would otherwise wipe what the user typed.)
    var searchSelectors = ['[data-cf-search-input]', '[data-cf-mobile-search-input]'];
    var searchSnapshots = searchSelectors.map(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return null;
      return {
        selector: sel,
        value: el.value,
        wasFocused: document.activeElement === el,
        selStart: el.selectionStart,
        selEnd: el.selectionEnd
      };
    });

    // Skip browser cache so /collections/all?filter.p.product_type=X
    // always re-fetches Shopify's freshly-filtered response. The
    // X-Requested-With header is dropped — a couple of Shopify storefront
    // proxies have been observed returning subtly different markup for
    // that header (no [data-globo-filter-items] in the response), which
    // makes the grid swap silently no-op and the page looks like the
    // filter did nothing.
    fetch(fetchUrl, { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
var newGrid = doc.querySelector('[data-globo-filter-items]');
var curGrid = document.querySelector('[data-globo-filter-items]');
if (newGrid && curGrid) {
  curGrid.replaceWith(newGrid);
} else if (!newGrid && curGrid) {
  // No grid in the response — static-search.liquid skips rendering
  // [data-globo-filter-items] entirely when product_count is 0,
  // showing only a .search-no-products message instead. Without this,
  // the previous search's products stayed frozen on screen since
  // there was nothing to replace them with.
  var emptyMsg = doc.querySelector('.search-no-products');
  var emptyText = emptyMsg ? emptyMsg.textContent.trim() : 'No products found';
  curGrid.innerHTML = '';
  var emptyEl = document.createElement('p');
  emptyEl.className = 'collection-page__empty-collection';
  emptyEl.textContent = emptyText;
  curGrid.appendChild(emptyEl);
} else if (!newGrid) {
  // Surface this loudly during debugging — if the response has no
  // grid container, Shopify either rendered an empty section or
  // sent back something other than the collection template.
  if (window.console && console.warn) {
    console.warn('[custom-collection-filter] fetched response had no [data-globo-filter-items]; grid not swapped', fetchUrl);
  }
}


        var newSidebar = doc.querySelector('#gf-tree');
        var curSidebar = document.querySelector('#gf-tree');
        if (newSidebar && curSidebar) {
          if (preserveFilters) {
            // Search mode: /search response has no filter blocks. Keep the existing
            // CATEGORY/STONE COLOR/METAL etc. intact, but refresh the product count
            // summary and active pills if they came back.
            var newSummary = newSidebar.querySelector('.gf-summary');
            var curSummary = curSidebar.querySelector('.gf-summary');
            if (newSummary && curSummary) curSummary.replaceWith(newSummary);
            else if (newSummary && !curSummary) curSidebar.appendChild(newSummary);
            // (Pills wrapper is re-rendered by renderActivePills() in bindAll.)
          } else {
            // Capture which filter blocks are currently EXPANDED so we can
            // re-apply that state after the swap. Without this, clicking a
            // filter while CATEGORY (or any other block) was open would
            // collapse it back to the server-rendered default (is-collapsed)
            // and the user has to re-open it every time.
            var expandedIds = {};
            curSidebar.querySelectorAll('.gf-option-block').forEach(function (b) {
              if (!b.classList.contains('is-collapsed')) {
                var id = b.getAttribute('data-filter-id');
                if (id) expandedIds[id] = true;
              }
            });
            curSidebar.replaceWith(newSidebar);
            // Re-apply expanded state on the freshly-swapped sidebar.
            newSidebar.querySelectorAll('.gf-option-block').forEach(function (b) {
              var id = b.getAttribute('data-filter-id');
              if (id && expandedIds[id]) b.classList.remove('is-collapsed');
            });
          }
        }

        var newLoadMore = doc.querySelector('.infinite-scroll');
        var curLoadMore = document.querySelector('.infinite-scroll');
        if (newLoadMore && curLoadMore) {
          curLoadMore.replaceWith(newLoadMore);
        } else if (newLoadMore) {
          // Insert right after the (just-swapped) grid — never at the end of
          // .collection-page__layout-main, which would land the button below
          // the collection's SEO text / post-grid rich text instead of
          // directly under the products.
          var gridForLoadMore = document.querySelector('[data-globo-filter-items]') || document.querySelector('.collection-page__product-list');
          if (gridForLoadMore && gridForLoadMore.parentNode) {
            gridForLoadMore.insertAdjacentElement('afterend', newLoadMore);
          } else {
            var main = document.querySelector('.collection-page__layout-main');
            if (main) main.appendChild(newLoadMore);
          }
        } else if (curLoadMore) {
          curLoadMore.remove();
        }

        // Replace .pagination too — bindLoadMore's hasMorePagesLive()
        // check uses the presence of .pagination .next a as ground
        // truth for whether more pages exist. If a previous state
        // (e.g. a Show-dropdown auto-fetch that exhausted pagination)
        // had removed it, ajaxNavigate's later swaps left .pagination
        // out and Load More then hid itself even when the new fetched
        // state had plenty of remaining pages.
        var newPagination = doc.querySelector('.collection-page .pagination');
        var curPagination = document.querySelector('.collection-page .pagination');
        if (newPagination && curPagination) {
          curPagination.replaceWith(newPagination);
        } else if (newPagination) {
          var mainForPag = document.querySelector('.collection-page__layout-main');
          if (mainForPag) mainForPag.appendChild(newPagination);
        } else if (curPagination) {
          curPagination.remove();
        }
        // Shopify's own numbered pagination is only kept around as an internal
        // "are there more pages?" signal for hasMorePagesLive() — it's never meant
        // to be user-facing (our custom infinite-scroll/Load More button replaces
        // it). /search responses (search.json hardcodes traditional_pagination,
        // never infinite_scroll) render this unconditionally, and normally CSS
        // hides it via the collection page's own pagination_method class — but
        // that class lives on the outer section this swap never touches, so force
        // it hidden here too rather than depending on that still lining up.
        if (newPagination) newPagination.style.display = 'none';

        window.history.pushState({}, '', displayUrl || fetchUrl);
        if (page) page.classList.remove('is-loading');

        if (window.Rimg && typeof window.Rimg.init === 'function') {
          window.Rimg.init();
        }

        // Restore search input values (and focus/caret for the one the user was typing in).
        searchSnapshots.forEach(function (snap) {
          if (!snap) return;
          var el = document.querySelector(snap.selector);
          if (!el) return;
          el.value = snap.value;
          if (snap.wasFocused) {
            el.focus();
            try {
              if (snap.selStart != null && snap.selEnd != null) {
                el.setSelectionRange(snap.selStart, snap.selEnd);
              }
            } catch (e) { /* some input types don't support setSelectionRange */ }
          }
        });

        bindAll();
      })
      .catch(function () {
        if (page) page.classList.remove('is-loading');
        window.location.href = displayUrl || fetchUrl;
      });
  }

  // On an individual collection page (not /collections/all, not /search), a text
  // search has to stay scoped to the current collection. /search has no native
  // notion of "current collection", so we add the same metafield filter Shopify's
  // own COLLECTION sidebar rows use (filter.p.m.custom.collection_names) — value
  // read from data-cf-collection-name on the .collection-page wrapper.
  function currentCollectionFilterValue() {
    var path = window.location.pathname;
    if (path === '/search' || path === '/collections/all' || path === '/collections/all/') return null;
    if (path.indexOf('/collections/') !== 0) return null;
    var page = document.querySelector('.collection-page[data-cf-collection-name]');
    if (!page) return null;
    var name = page.getAttribute('data-cf-collection-name');
    return name ? name.trim() : null;
  }

  // Build the fetch URL based on whatever params the browser bar currently shows
  // (q, filter.*, sort_by). If `q` is present we hit /search; otherwise the collection.
  // `mutate` is an optional function that adjusts the URLSearchParams before building.
  function buildFetchAndDisplay(mutate) {
    var u = new URL(window.location.href);
    if (typeof mutate === 'function') mutate(u.searchParams);
    u.searchParams.delete('page');

    var q = (u.searchParams.get('q') || '').trim();
    var isSearch = !!q;

    // Scope a text search fired from an individual collection page to that
    // collection's own products (see currentCollectionFilterValue()) —
    // without this, /search has no notion of "current collection" and
    // matches the entire shop. Added to u.searchParams (not just the fetch
    // URL) so it's also reflected in the address bar and shows as an active
    // filter pill, same as clicking the sidebar's COLLECTION row would.
    if (isSearch) {
      var collectionScope = currentCollectionFilterValue();
      if (collectionScope && u.searchParams.getAll('filter.p.m.custom.collection_names').indexOf(collectionScope) < 0) {
        u.searchParams.append('filter.p.m.custom.collection_names', collectionScope);
      }
    }

    // Display URL: always the collection path with the (possibly mutated) params.
    var displayUrl = window.location.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');

    // Fetch URL.
    var fetchUrl;
    if (isSearch) {
      // /search?q=...&type=product&filter.p.x=...&sort_by=...
      // Skip 'q' (we set it explicitly) AND 'type' (we set it
      // explicitly to 'product'); otherwise the current URL's type=product
      // gets appended as a duplicate, which a couple of Shopify proxies
      // have been observed mishandling — silently dropping the trailing
      // filter.p.* params after the duplicate, so the response came back
      // unfiltered and the user saw the full search-result set instead
      // of the narrowed one (and the Load More button vanished because
      // the broad set then fits a much smaller fraction of pages).
      var sp = new URLSearchParams();
      sp.set('q', q);
      sp.set('type', 'product');
      u.searchParams.forEach(function (val, key) {
        if (key === 'q' || key === 'type') return;
        sp.append(key, val);
      });
      fetchUrl = '/search?' + sp.toString();
    } else {
      fetchUrl = displayUrl;
    }

    return { fetchUrl: fetchUrl, displayUrl: displayUrl, isSearch: isSearch };
  }

  // Dedicated search handler — sets/clears `q` and routes through buildFetchAndDisplay.
  // /search now renders its own filter sidebar from search.results, so we no longer
  // need preserveFilters — letting the swap replace the sidebar means filter rows
  // update to reflect the search match set (e.g. searching on /collections/bridal
  // re-scopes the CATEGORY/COLLECTION/STONE COLOR/METAL lists to whatever results
  // the search returned).
  function ajaxSearch(query) {
    var q = (query || '').trim();
    var built = buildFetchAndDisplay(function (params) {
      if (q) params.set('q', q);
      else params.delete('q');
    });
    ajaxNavigate(built.fetchUrl, built.displayUrl);
  }

  function bindCollapseToggle() {
    document.querySelectorAll('.gf-option-block [data-cf-toggle]').forEach(function (el) {
      if (el.__cfBound) return;
      el.__cfBound = true;
      el.addEventListener('click', function () {
        var block = el.closest('.gf-option-block');
        if (block) block.classList.toggle('is-collapsed');
      });
    });
  }

  function bindFilterLinks() {
    document.querySelectorAll('[data-cf-filter-link]').forEach(function (link) {
      if (link.__cfBound) return;
      link.__cfBound = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var key = link.getAttribute('data-cf-key');
        var val = link.getAttribute('data-cf-value');
        var built = buildFetchAndDisplay(function (params) {
          var existing = params.getAll(key);
          if (existing.indexOf(val) >= 0) {
            var remaining = existing.filter(function (v) { return v !== val; });
            params.delete(key);
            remaining.forEach(function (v) { params.append(key, v); });
          } else {
            params.append(key, val);
          }
        });
        ajaxNavigate(built.fetchUrl, built.displayUrl, { preserveFilters: built.isSearch });
      });
    });
  }

  function bindSearch() {
    var form = document.querySelector('[data-cf-search-form]');
    var input = document.querySelector('[data-cf-search-input]');
    var clearBtn = document.querySelector('[data-cf-search-clear]');
    if (!form || !input) return;
    if (form.__cfBound) return;
    form.__cfBound = true;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ajaxSearch(input.value);
    });

    var debounce;
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        ajaxSearch(input.value);
      }, 500);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        ajaxSearch('');
      });
    }
  }

  function markActiveFilters() {
    var u = new URL(window.location.href);
    document.querySelectorAll('[data-cf-filter-link]').forEach(function (link) {
      var key = link.getAttribute('data-cf-key');
      var val = link.getAttribute('data-cf-value');
      var values = u.searchParams.getAll(key);
      var li = link.closest('li');
      if (values.indexOf(val) >= 0) {
        link.classList.add('checked');
        if (li) li.classList.add('is-selected');
        link.setAttribute('aria-current', 'true');
      } else {
        link.classList.remove('checked');
        if (li) li.classList.remove('is-selected');
        link.removeAttribute('aria-current');
      }
    });
  }

  function applyLimit(n) {
    var items = document.querySelectorAll('.collection-page__product-list > .product-item');
    items.forEach(function (item, i) {
      item.style.display = i < n ? '' : 'none';
    });
  }

  // Build a fetch URL for page N from the address-bar URL — preserves
  // every active filter/sort/q. Mirrors collection-load-more.js's
  // buildPageFetchUrl so the Show dropdown and Load More both follow
  // the same routing rules (and never drop filter params by
  // resolving a relative ?page=N href against the address bar).
  function buildPageFetchUrl(pageNum) {
    var u = new URL(window.location.href);
    var q = (u.searchParams.get('q') || '').trim();
    if (q) {
      var sp = new URLSearchParams();
      sp.set('q', q);
      sp.set('type', 'product');
      u.searchParams.forEach(function (val, key) {
        if (key === 'q' || key === 'type' || key === 'page') return;
        sp.append(key, val);
      });
      if (pageNum > 1) sp.set('page', String(pageNum));
      return '/search?' + sp.toString();
    }
    u.searchParams.delete('page');
    if (pageNum > 1) u.searchParams.set('page', String(pageNum));
    return u.toString();
  }

  function fetchAndAppendUntilCount(target, iterCount) {
    iterCount = iterCount || 0;

    var grid = document.querySelector('[data-globo-filter-items]');
    if (!grid) return Promise.resolve();
    var current = grid.querySelectorAll('.product-item').length;
    if (current >= target) return Promise.resolve();

    // Authoritative "more pages exist?" check — uses pagination presence,
    // not the href (which we rebuild ourselves so filters survive).
    if (!document.querySelector('.collection-page .pagination .next a')) {
      return Promise.resolve();
    }

    // Safety bound: never recurse more than 20 times in one Show change.
    // Defends against any pathological scenario where the fetched response
    // re-introduces a .next a without actually adding new dedup-able
    // products (which would otherwise spin forever and trap is-loading on).
    if (iterCount >= 20) return Promise.resolve();

    // Derive next page from grid count, not from a recursion arg. Self
    // -correcting: if a previous Show or Load More click already brought
    // page 2 into the grid, current/PAGE_SIZE+1 jumps straight to page 3.
    // PAGE_SIZE must match the section's paginate-by count
    // (static-collection.liquid / static-search.liquid default to 36).
    var PAGE_SIZE = 36;
    var nextPage = Math.floor(current / PAGE_SIZE) + 1;
    var fetchUrl = buildPageFetchUrl(nextPage);

    return fetch(fetchUrl, { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // De-dupe by data-product-item-id so we never paste a product that's
        // already on screen (defensive against cache/echo).
        var existingIds = {};
        grid.querySelectorAll('.product-item[data-product-item-id]').forEach(function (item) {
          existingIds[item.getAttribute('data-product-item-id')] = true;
        });

        var newProducts = doc.querySelectorAll('[data-globo-filter-items] .product-item');
        var anyAppended = false;
        newProducts.forEach(function (p) {
          var id = p.getAttribute('data-product-item-id');
          if (id && existingIds[id]) return;
          grid.appendChild(p);
          if (id) existingIds[id] = true;
          anyAppended = true;
        });

        // Replace pagination AND the Load More button container with the
        // fetched response's versions — otherwise the stale buttons stay
        // visible after the Show dropdown's auto-fetch swallowed the
        // remaining pages, and clicking Load More would re-fetch.
        var newPagination = doc.querySelector('.collection-page .pagination');
        var curPagination = document.querySelector('.collection-page .pagination');
        if (newPagination && curPagination) curPagination.replaceWith(newPagination);
        else if (!newPagination && curPagination) curPagination.remove();
        // Kept only as hasMorePagesLive()'s internal signal — never user-facing.
        if (newPagination) newPagination.style.display = 'none';

        var newLoadMore = doc.querySelector('.infinite-scroll');
        var curLoadMore = document.querySelector('.infinite-scroll');
        if (newLoadMore && curLoadMore) curLoadMore.replaceWith(newLoadMore);
        else if (!newLoadMore && curLoadMore) curLoadMore.remove();

        if (window.Rimg && typeof window.Rimg.init === 'function') window.Rimg.init();

        // If a fetch yielded zero new products (full dedup), bail out
        // instead of spinning on the same page forever.
        if (!anyAppended) return;

        return fetchAndAppendUntilCount(target, iterCount + 1);
      });
  }

  function bindLimitSelect() {
    var sel = document.querySelector('[data-cf-limit]');
    if (!sel || sel.__cfBound) return;
    sel.__cfBound = true;

    function applyN(n) {
      var page = document.querySelector('.collection-page');
      if (page) page.classList.add('is-loading');

      function done() {
        if (page) page.classList.remove('is-loading');
      }

      return fetchAndAppendUntilCount(n).then(function () {
        applyLimit(n);
        // .infinite-scroll may have been swapped during auto-fetch;
        // re-bind so a click on the new button does the right thing
        // (or that the button correctly hides itself when no more
        // pages remain).
        if (window.CFLoadMore && typeof window.CFLoadMore.bind === 'function') {
          window.CFLoadMore.bind();
        }
        done();
      }, function () {
        // Reject branch — fetch failed, recursion threw, etc. Always
        // clear is-loading so the page stays interactive. Previously
        // we only had a .then() handler, so any rejection stranded the
        // page with is-loading stuck on and every click blocked.
        done();
      });
    }

    sel.addEventListener('change', function () {
      var n = parseInt(sel.value, 10) || 12;
      applyN(n);
    });

    var initial = parseInt(sel.value, 10);
    if (initial) applyN(initial);
  }

  // Sort dropdown handlers run via a single document-level listener so
  // they survive any DOM re-rendering (sidebar replacement, toolbar
  // swap, etc.) without depending on __cfBound flags lining up across
  // AJAX swaps. Previously each [data-cf-sort] option was bound once
  // by bindSortDropdown — if the same DOM element ever ended up
  // marked __cfBound from a stale state, subsequent re-binds would
  // skip it and clicks did nothing.
  function bindSortDropdown() {
    if (window.__cfSortDelegateBound) return;
    window.__cfSortDelegateBound = true;

    document.addEventListener('click', function (e) {
      // Open/close the dropdown when the toggle is clicked.
      var toggle = e.target.closest('[data-cf-sort-toggle]');
      if (toggle) {
        e.stopPropagation();
        var sb = toggle.closest('.sort-by');
        if (sb) {
          var isActive = sb.classList.toggle('active');
          toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
        return;
      }

      // Apply the chosen sort when an option is clicked.
      var opt = e.target.closest('[data-cf-sort]');
      if (opt) {
        e.preventDefault();
        var v = opt.getAttribute('data-sort');
        var parent = opt.closest('.sort-by');
        if (parent) {
          parent.classList.remove('active');
          var t = parent.querySelector('[data-cf-sort-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
        var built = buildFetchAndDisplay(function (params) {
          if (v) params.set('sort_by', v);
          else params.delete('sort_by');
        });
        ajaxNavigate(built.fetchUrl, built.displayUrl, { preserveFilters: built.isSearch });
        return;
      }

      // Click outside any open sort dropdown closes it.
      document.querySelectorAll('.sort-by.active').forEach(function (sb) {
        if (!sb.contains(e.target)) {
          sb.classList.remove('active');
          var t = sb.querySelector('[data-cf-sort-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  // Sync the visible sort label and the dropdown's .is-active row with
  // whatever sort_by the URL currently has. Needed on /search because
  // the Liquid reads collection.sort_by — which is nil on a search
  // template — so the label always falls through to "Featured" even
  // after the user picks Price, low to high.
  var SORT_LABELS = {
    'manual': 'Featured',
    'featured': 'Featured',
    'best-selling': "What's New",
    'stock-descending': 'Availability',
    'title-ascending': 'Alphabetically, A-Z',
    'title-descending': 'Alphabetically, Z-A',
    'price-ascending': 'Price, low to high',
    'price-descending': 'Price, high to low',
    'created-descending': 'Date, new to old',
    'created-ascending': 'Date, old to new',
    'relevance': 'Relevance'
  };
  function syncSortLabel() {
    var sortBy = (new URL(window.location.href)).searchParams.get('sort_by') || 'manual';
    var toggleSpan = document.querySelector('[data-cf-sort-toggle] span');
    if (toggleSpan && SORT_LABELS[sortBy]) {
      toggleSpan.textContent = SORT_LABELS[sortBy];
    }
    document.querySelectorAll('[data-cf-sort]').forEach(function (opt) {
      if (opt.getAttribute('data-sort') === sortBy) {
        opt.classList.add('is-active');
      } else {
        opt.classList.remove('is-active');
      }
    });
  }

  function bindMobileSearch() {
    var form = document.querySelector('[data-cf-mobile-search-form]');
    var input = document.querySelector('[data-cf-mobile-search-input]');
    if (!form || !input || form.__cfBound) return;
    form.__cfBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ajaxSearch(input.value);
    });
  }

  function renderActivePills() {
    var wrapper = document.querySelector('[data-cf-active-pills]');
    if (!wrapper) return;

    // Track two things per (key, val) pair found in the sidebar:
    //   blockLabelMap  - the parent block's heading (e.g. "CATEGORY")
    //   valueLabelMap  - the row's friendly value label from <span class="gf-label">
    //                    (e.g. "Earrings" for Shopify's Standard:Category value
    //                    "aa-6-5", or just "Black" for a tag filter where val == label)
    var blockLabelMap = {};
    var valueLabelMap = {};
    document.querySelectorAll('#gf-tree .gf-option-block').forEach(function (block) {
      var heading = block.querySelector('.gf-block-title .h3 span, .gf-block-title .h3, .gf-block-title');
      var label = heading ? heading.textContent.trim() : '';
      block.querySelectorAll('[data-cf-filter-link]').forEach(function (link) {
        var key = link.getAttribute('data-cf-key');
        var val = link.getAttribute('data-cf-value');
        if (!key || !val) return;
        blockLabelMap[key + ' ' + val] = label || key;
        var rowLabelEl = link.querySelector('.gf-label');
        if (rowLabelEl) {
          var rowLabel = rowLabelEl.textContent.trim();
          if (rowLabel) valueLabelMap[key + ' ' + val] = rowLabel;
        }
      });
    });

    var pills = [];
var u = new URL(window.location.href);
var autoCollectionScope = currentCollectionFilterValue();
u.searchParams.forEach(function (val, key) {
  if (key.indexOf('filter.') !== 0) return;
  // Skip the collection-scope filter buildFetchAndDisplay() auto-injects
  // for searches on an individual collection page — it isn't a real
  // filter choice the user made, and buildFetchAndDisplay re-adds it on
  // every subsequent request anyway, so a clickable "x" here would just
  // look broken (clear it, nothing visibly changes).
  if (key === 'filter.p.m.custom.collection_names' && val === autoCollectionScope) return;
  // Price needs special pill formatting: convert cents -> "$N" and use
  // the PRICE block heading instead of "PRICE.GTE" / "PRICE.LTE".

      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        var dollars = (parseInt(val, 10) || 0) / 100;
        var prefix = key === 'filter.v.price.gte' ? '≥ $' : '≤ $';
        var dollarsStr = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
        pills.push({ key: key, val: val, label: 'PRICE', valLabel: prefix + dollarsStr });
        return;
      }
      var label = blockLabelMap[key + ' ' + val];
      if (!label) {
        label = key.replace(/^filter\.[pv]\./, '').replace(/_/g, ' ').toUpperCase();
      }
      var valLabel = valueLabelMap[key + ' ' + val] || val;
      pills.push({ key: key, val: val, label: label, valLabel: valLabel });
    });

    if (pills.length === 0) {
      wrapper.innerHTML = '';
      return;
    }

    var collectionUrl = wrapper.getAttribute('data-cf-collection-url') || window.location.pathname;

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    var html = '';
    html += '<div class="gf-block-title hidden-xs">';
    html += '<div class="h3"><span>Filter By</span></div>';
    html += '<a href="' + esc(collectionUrl) + '" class="gf-refine-toggle hidden-xs" data-cf-clear-all>Clear All</a>';
    html += '</div>';
    html += '<div class="gf-block-content globo-selected-items">';
    html += '<button type="button" class="clear-refinements visible-xs" data-cf-clear-all data-cf-clear-url="' + esc(collectionUrl) + '">Clear All</button>';
    pills.forEach(function (p) {
      // The toggle handler matches by data-cf-value (the URL value),
      // so we keep p.val on the data attribute. The visible label,
      // however, is p.valLabel — Shopify's Standard:Category source
      // uses opaque IDs (e.g. "aa-6-5") for the value, with the human
      // label living in the sidebar row's .gf-label span.
      html += '<div class="selected-item gf-option-label">';
      html += '<a href="#" data-cf-filter-link data-cf-key="' + esc(p.key) + '" data-cf-value="' + esc(p.val) + '">';
      html += '<span class="selected-item">';
      html += '<span class="hidden-xs">' + esc(p.label) + '</span>';
      html += '<strong><span class="gf-label">' + esc(p.valLabel) + '</span></strong>';
      html += '</span>';
      html += '<span class="gf-clear"></span>';
      html += '</a>';
      html += '</div>';
    });
    html += '</div>';
    wrapper.innerHTML = html;
  }

  function bindClearAll() {
    document.querySelectorAll('[data-cf-clear-all]').forEach(function (link) {
      if (link.__cfBound) return;
      link.__cfBound = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = link.getAttribute('href') || link.getAttribute('data-cf-clear-url');
        if (url) ajaxNavigate(url);
      });
    });
  }

  function bindMobileDrawer() {
    var openBtn = document.querySelector('[data-cf-open-drawer]');
    var closeBtn = document.querySelector('[data-cf-close-drawer]');
    if (openBtn && !openBtn.__cfBound) {
      openBtn.__cfBound = true;
      openBtn.addEventListener('click', function () {
        document.body.classList.add('offcanvas-open');
      });
    }
    if (closeBtn && !closeBtn.__cfBound) {
      closeBtn.__cfBound = true;
      closeBtn.addEventListener('click', function () {
        document.body.classList.remove('offcanvas-open');
      });
    }
    if (!document.body.__cfDrawerBound) {
      document.body.__cfDrawerBound = true;
      document.body.addEventListener('click', function (e) {
        if (!document.body.classList.contains('offcanvas-open')) return;
        var tree = document.getElementById('gf-tree');
        if (tree && !tree.contains(e.target) && !e.target.closest('[data-cf-open-drawer]')) {
          document.body.classList.remove('offcanvas-open');
        }
      });
    }
  }

  // Cache of full-collection counts keyed by handle. The Liquid in
  // custom-collection-sidebar.liquid only sees the first 50 products
  // (paginate.by cap), so categories whose products live past index 50
  // render no count. We fetch the rest via products.json and overlay
  // accurate counts once they land.
  var __cfCountCache = {};

  function injectFilterCounts(counts) {
    document.querySelectorAll('#gf-tree .gf-filter-contents [data-cf-filter-link]').forEach(function (link) {
      var key = link.getAttribute('data-cf-key');
      var val = link.getAttribute('data-cf-value');
      var label = link.querySelector('.gf-label');

      // We only know how to count two kinds of filter keys from the
      // products.json fetch: filter.p.product_type and filter.p.tag. Other
      // keys (e.g. Shopify's Standard: Category source, which uses something
      // like filter.p.product_category or a metafield path) come straight
      // from collection.filters with accurate Shopify counts already baked
      // into the Liquid. Leave those rows alone — touching them would zero
      // out a perfectly good count and trigger the hide-empty pass.
      var hasMappedKey = (key === 'filter.p.product_type' || key === 'filter.p.tag');
      if (!hasMappedKey) return;

      var count = 0;
      if (key === 'filter.p.product_type') count = counts.types[val] || 0;
      else if (key === 'filter.p.tag') count = counts.tags[val] || 0;

      var item = link.closest('li') || link;
      var existing = link.querySelector('.gf-count');
      // COLLECTION filter is a navigation/discovery list of sibling
      // collections, not a strict tag filter — products in a given
      // collection often aren't tagged with their own collection name,
      // so zero-count entries here are expected and we should keep
      // them rendered (just without a count badge).
      var blockEl = link.closest('.gf-option-block');
      var isCollectionBlock = blockEl && blockEl.getAttribute('data-filter-id') === '72709';

      if (count > 0) {
        item.removeAttribute('data-cf-zero');
        item.style.display = '';
        if (label) {
          if (existing) {
            existing.textContent = '(' + count + ')';
          } else {
            var span = document.createElement('span');
            span.className = 'gf-count';
            span.textContent = '(' + count + ')';
            label.parentNode.insertBefore(span, label.nextSibling);
          }
        }
      } else if (isCollectionBlock) {
        // Keep COLLECTION rows visible at zero count; just clear any stale
        // count span (e.g. left over from a previous AJAX state).
        item.removeAttribute('data-cf-zero');
        item.style.display = '';
        if (existing) existing.remove();
      } else {
        // collection.all_types / .all_tags occasionally reports values that
        // aren't actually present in the live product set — hide those rows
        // rather than show "Bracelet" with no products under it.
        item.setAttribute('data-cf-zero', '');
        item.style.display = 'none';
        if (existing) existing.remove();
      }
    });

    // Hide any filter block whose every row got zero'd out — but never
    // collapse the COLLECTION block itself.
    document.querySelectorAll('#gf-tree .gf-filter-contents .gf-option-block').forEach(function (block) {
      if (block.getAttribute('data-filter-id') === '72709') {
        block.style.display = '';
        return;
      }
      var visibleRows = block.querySelectorAll('li:not([data-cf-zero])');
      block.style.display = visibleRows.length === 0 ? 'none' : '';
    });
  }

  function loadCollectionCounts() {
    // When the page has a search query, the rendered grid + sidebar already
    // reflect search.results (Liquid built the count CSVs from those). Fetching
    // /collections/{handle}/products.json would give counts for the whole
    // collection regardless of `q`, which would clobber the correct
    // search-scoped counts. Skip the overlay in that case.
    var hasQuery = new URL(window.location.href).searchParams.get('q');
    if (hasQuery) return;

    var match = window.location.pathname.match(/^\/collections\/([^\/]+)/);
    if (!match) return;
    var handle = match[1];

    if (__cfCountCache[handle]) {
      injectFilterCounts(__cfCountCache[handle]);
      return;
    }

    var types = {};
    var tags = {};

    function fetchPage(page) {
      var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          products.forEach(function (p) {
            if (p.product_type) {
              types[p.product_type] = (types[p.product_type] || 0) + 1;
            }
            var t = p.tags;
            if (typeof t === 'string') {
              t = t.split(',').map(function (s) { return s.trim(); });
            }
            (t || []).forEach(function (tag) {
              if (tag) tags[tag] = (tags[tag] || 0) + 1;
            });
          });
          if (products.length === 250) return fetchPage(page + 1);
        });
    }

    fetchPage(1)
      .then(function () {
        var result = { types: types, tags: tags };
        __cfCountCache[handle] = result;
        injectFilterCounts(result);
      })
      .catch(function () { /* leave Liquid-rendered counts in place on failure */ });
  }

  // Update the COLLECTION block's nav-link rows from a {handle -> count} map.
  // These rows don't carry data-cf-filter-link so injectFilterCounts skips
  // them — handle separately.
  function injectCollectionCounts(collectionCounts) {
    var block = document.querySelector('[data-filter-id="72709"]');
    if (!block) return;
    block.querySelectorAll('li').forEach(function (li) {
      var a = li.querySelector('a[href^="/collections/"]');
      if (!a) return;
      var handle = a.getAttribute('href').replace(/^\/collections\//, '').split('?')[0];
      var count = collectionCounts[handle] || 0;
      var label = a.querySelector('.gf-label');
      var existing = a.querySelector('.gf-count');
      if (count > 0) {
        li.style.display = '';
        if (existing) {
          existing.textContent = '(' + count + ')';
        } else if (label) {
          var span = document.createElement('span');
          span.className = 'gf-count';
          span.textContent = '(' + count + ')';
          label.parentNode.insertBefore(span, label.nextSibling);
        }
      } else {
        li.style.display = 'none';
        if (existing) existing.remove();
      }
    });
  }

  // Counts on /search start out capped at the first paginate page (max 50)
  // because Shopify's {% paginate %} can't see beyond that. Re-fetch every
  // page of /search?q=... in the background and refine the sidebar counts
  // from the data-product-* attributes baked into each product card.
  function loadSearchCounts() {
    var u = new URL(window.location.href);
    var q = (u.searchParams.get('q') || '').trim();
    if (!q) return;

    var cacheKey = 'search:' + q + ':' + (currentCollectionFilterValue() || '');
    if (__cfCountCache[cacheKey]) {
      injectFilterCounts(__cfCountCache[cacheKey]);
      injectCollectionCounts(__cfCountCache[cacheKey].collections);
      return;
    }

    var types = {};
    var tags = {};
    var cols = {};

    function processCard(article) {
      var pt = article.getAttribute('data-product-type');
      var ptags = article.getAttribute('data-product-tags');
      var pcols = article.getAttribute('data-product-collections');
      if (pt) types[pt] = (types[pt] || 0) + 1;
      if (ptags) ptags.split('|').forEach(function (t) {
        t = t.trim();
        if (t) tags[t] = (tags[t] || 0) + 1;
      });
      if (pcols) pcols.split('|').forEach(function (h) {
        h = h.trim();
        if (h) cols[h] = (cols[h] || 0) + 1;
      });
    }

    function fetchPage(page) {
      var url = '/search?q=' + encodeURIComponent(q) + '&type=product&page=' + page;
      var collectionScope = currentCollectionFilterValue();
      if (collectionScope) {
        url += '&filter.p.m.custom.collection_names=' + encodeURIComponent(collectionScope);
      }
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.collection-page__product-list .product-item');
          cards.forEach(processCard);
          var hasNext = doc.querySelector('.collection-page .pagination .next a') != null;
          return cards.length > 0 && hasNext;
        });
    }

    function recurse(page) {
      if (page > 20) return Promise.resolve();
      return fetchPage(page).then(function (more) {
        if (more) return recurse(page + 1);
      });
    }

    recurse(1)
      .then(function () {
        var result = { types: types, tags: tags, collections: cols };
        __cfCountCache[cacheKey] = result;
        injectFilterCounts(result);
        injectCollectionCounts(cols);
      })
      .catch(function () { /* leave Liquid-rendered counts in place on failure */ });
  }

  // Wire the PRICE block (rendered by custom-collection-sidebar.liquid when
  // S&D exposes a price_range filter). User types dollar values; we convert
  // to cents and ajaxNavigate with filter.v.price.gte / .lte. Empty / range-max
  // values are dropped so the URL doesn't carry a redundant bound.
  function bindPriceFilter() {
    var block = document.querySelector('[data-cf-price-filter]');
    if (!block) return;
    var minInput = block.querySelector('[data-cf-price-min]');
    var maxInput = block.querySelector('[data-cf-price-max]');
    var applyBtn = block.querySelector('[data-cf-price-apply]');
    if (!applyBtn || applyBtn.__cfBound) return;
    applyBtn.__cfBound = true;

    function parseDollars(input) {
      if (!input) return null;
      var v = String(input.value || '').trim();
      if (v === '') return null;
      var n = parseFloat(v);
      if (isNaN(n) || n < 0) return null;
      return Math.round(n * 100);
    }

    function apply() {
      var minCents = parseDollars(minInput);
      var maxCents = parseDollars(maxInput);
      var built = buildFetchAndDisplay(function (params) {
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        if (minCents != null && minCents > 0) params.set('filter.v.price.gte', String(minCents));
        if (maxCents != null) params.set('filter.v.price.lte', String(maxCents));
      });
      ajaxNavigate(built.fetchUrl, built.displayUrl, { preserveFilters: built.isSearch });
    }

    applyBtn.addEventListener('click', apply);
    [minInput, maxInput].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          apply();
        }
      });
    });
  }

  // On an individual collection page (not /collections/all, not /search),
  // if the URL has no sort_by, force title-ascending. Shopify can only
  // re-sort via a URL param — collection.default_sort_by is set per-
  // collection in admin and we can't override it from theme code — so
  // we ajaxNavigate to add the param, which both re-fetches the page in
  // alphabetical order and updates history.
  // Runs once per page load (guarded by a window flag) so AJAX-driven
  // re-binds don't re-trigger.
  // Returns true if it triggered an ajaxNavigate (caller should skip
  // further binders since the content area is about to be swapped and
  // bindAll() will be re-invoked on the new HTML).
  // function applyDefaultSortIfNeeded() {
  //   if (window.__cfDefaultSortApplied) return false;
  //   var url = new URL(window.location.href);
  //   if (url.searchParams.get('sort_by')) {
  //     window.__cfDefaultSortApplied = true;
  //     return false;
  //   }
  //   var path = window.location.pathname;
  //   if (path === '/search' || path === '/collections/all' || path === '/collections/all/') return false;
  //   if (path.indexOf('/collections/') !== 0) return false;
  //   window.__cfDefaultSortApplied = true;
  //   var built = buildFetchAndDisplay(function (params) {
  //     params.set('sort_by', 'manual');
  //   });
  //   ajaxNavigate(built.fetchUrl, built.displayUrl);
  //   return true;
  // }


  function applyDefaultSortIfNeeded() {
    return false;
  }

  function bindAll() {
    if (applyDefaultSortIfNeeded()) return;
    renderActivePills();
    bindCollapseToggle();
    bindFilterLinks();
    bindSearch();
    bindMobileSearch();
    bindLimitSelect();
    bindSortDropdown();
    syncSortLabel();
    bindMobileDrawer();
    bindClearAll();
    bindPriceFilter();
    markActiveFilters();
    loadCollectionCounts();
    loadSearchCounts();
    if (window.CFLoadMore && typeof window.CFLoadMore.bind === 'function') {
      window.CFLoadMore.bind();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
